import { flatten } from 'lottie-colorify';
import { Color } from '@cvent/blocks/utils/types';
import chroma from 'chroma-js';
import json from './confirmationCheck.json';

/**
 * This is a checkmark animation for the registration confirmation modal.
 * @param color - the color of the animation
 * @returns the recolored animation
 */
export const confirmationCheckLottie = (color: Color) => {
  const hexColor = chroma(color).hex();

  // lottie-colorify doesn't work with part of this, so we need to fix the color manually
  const [r, g, b] = chroma(color)
    .rgb()
    .map((value: number) => value / 255);
  json.layers[0].ef[0].ef[3].v.k = [r, g, b, 1];

  return flatten(hexColor, json);
};
